module.exports = __webpack_public_path__ + "static/media/parking-circle.cd2e86a0.svg";